"use client"
import { useState } from "react"
import { Container, Typography, Box, Paper, Button, useTheme, Avatar, Grid } from "@mui/material"
import ContactMailIcon from "@mui/icons-material/ContactMail"
import DiscordIcon from "@mui/icons-material/Chat"
import ContactModal from "../components/ContactModal"
import config from "../config"

const Contact = () => {
  const theme = useTheme()
  const [modalOpen, setModalOpen] = useState(false)
  const DISCORD_INVITE_LINK = config.DISCORD_INVITE_LINK || "https://discord.gg/4Sy9nGasJV"
  const OWNER_AVATAR = "https://cdn.discordapp.com/avatars/425436301047627806/ddf92daef47c355954e73d2a0e72188a.png"

  const handleOpenModal = () => {
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
  }

  return (
    <Container maxWidth="md">
      <Paper
        elevation={3}
        sx={{
          p: 4,
          background: "rgba(13, 15, 25, 0.7)",
          border: "1px solid rgba(0, 229, 255, 0.1)",
          borderRadius: 2,
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.5)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 4, gap: 2 }}>
          <ContactMailIcon
            sx={{
              fontSize: 40,
              color: theme.palette.primary.main,
              textShadow: "0 0 8px rgba(0, 229, 255, 0.6)",
            }}
          />
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: "bold",
              background: "linear-gradient(45deg, #ffffff 30%, #00e5ff 90%)",
              backgroundClip: "text",
              textFillColor: "transparent",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              textShadow: "0 0 2px rgba(0, 229, 255, 0.5)",
            }}
          >
            Contact Us
          </Typography>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
              <Typography variant="h6" sx={{ color: theme.palette.primary.main, mb: 2 }}>
                Get in Touch
              </Typography>
              <Typography variant="body1" paragraph>
                Have questions, feedback, or need support with DarkEdge? We're here to help! The fastest way to get
                assistance is through our Discord community.
              </Typography>

              <Typography variant="body1" paragraph sx={{ mt: 2 }}>
                Join our
                community to get help, share feedback, and stay updated on the latest features and announcements.
              </Typography>

              <Box sx={{ mt: "auto", pt: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={handleOpenModal}
                  sx={{
                    background: "linear-gradient(45deg, #00e5ff 30%, #2979ff 90%)",
                    boxShadow: "0 0 10px rgba(0, 229, 255, 0.5)",
                    "&:hover": {
                      boxShadow: "0 0 15px rgba(0, 229, 255, 0.8)",
                    },
                  }}
                >
                  Contact Developer
                </Button>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                p: 3,
                bgcolor: "rgba(0, 0, 0, 0.3)",
                borderRadius: 2,
                border: "1px solid rgba(255, 255, 255, 0.1)",
              }}
            >
              <Avatar
                src={OWNER_AVATAR}
                alt="Tawaret"
                sx={{
                  width: 100,
                  height: 100,
                  mb: 2,
                  border: "2px solid rgba(0, 229, 255, 0.5)",
                  boxShadow: "0 0 10px rgba(0, 229, 255, 0.3)",
                }}
              />
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 0.5 }}>
                tawaret_
              </Typography>
              <Typography variant="body2" sx={{ color: "rgba(255, 255, 255, 0.7)", mb: 3 }}>
                @Tawaret
              </Typography>
              <Typography variant="body2" sx={{ textAlign: "center", mb: 3 }}>
                Lead Developer & Owner
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <ContactModal open={modalOpen} onClose={handleCloseModal} />
    </Container>
  )
}

export default Contact
